import { render, staticRenderFns } from "./StandartsCatalogStandartPage.vue?vue&type=template&id=6940023c&"
import script from "./StandartsCatalogStandartPage.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogStandartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports